import { Route, Routes } from 'react-router-dom';
import { WorkButtonPage } from './WorkButtonPage/WorkButtonPage';
import { WorkContext } from './WorkPage';
import { WorkUpgradePage } from '../WorkUpgradePage/WorkUpgradePage';

export const WorkRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<WorkButtonPage />} />
            <Route path={`${WorkContext.Upgrade}`} element={ <WorkUpgradePage /> } />
        </Routes>
    );
};